import { lazy } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Features from "website/Features";
import HelpCenter from "website/HelpCenter";
import MyIndiciForProviders from "website/MyIndiciForProviders";
import OurStory from "website/OurStory";
import Video from "website/VideoSuite"
import FAQ from 'website/FAQs'
import ContactUs from 'website/ContactUs'
import OurStorySec from "website/ourstorysections/OurStorySec";
import MyAccordion from "website/MyAccordion";
// import ViewCompanies from "pages/home/CompnayOnBoarding/ViewCompanies";
//import your pages here
// const Dashboard = lazy(() => import('pages/home/Dashboard'))
// const Login = lazy(() => import('pages/auth/Login'))
const Home = lazy(() => import('../website/Home'))
// const AboutUs = lazy(() => import('../website/AboutUs'))
type routeItem = {
    path: string,
    key: string,
    exact: boolean,
    component: any,
}
type routes = routeItem & {
    routes?: routeItem[]
}
const ROUTES: routes[] = [
    {
        path: "/",
        key: "1",
        exact: true,
        component:Home,
    },
    // {
    //     path: "/",
    //     key: "1",
    //     exact: true,
    //     component: Home,
    // },
    {
        path: "/our-story",
        key: "2",
        exact: true,
        component: OurStory,
    },
    {
        path: "/features",
        key: "3",
        exact: true,
        component: Features,
    },
    {
        path: "/myindici-for-providers",
        key: "4",
        exact: true,
        component: MyIndiciForProviders,
    },
    {
        path: "/help-center",
        key: "5",
        exact: true,
        component: HelpCenter,
    },
    {
        path: "/videos",
        key: "6",
        exact: true,
        component: Video,
    },
    {
        path: "/faqs",
        key: "7",
        exact: true,
        component: FAQ,
    },
    {
        path: "/contactus",
        key: "8",
        exact: true,
        component: ContactUs,
    },
    {
        path: "/xyz",
        key: "9",
        exact: true,
        component: MyAccordion,
    },
];

// const ROUTES: routes[] = [
//     {
//         path: "/",
//         key: "1",
//         exact: true,
//         component: Home,
//         routes: [
//             {
//                 path: "/",
//                 key: "1",
//                 exact: true,
//                 component: Home,
//             }
//         ],
//     },
//     {
//         path: "/our-story",
//         key: "2",
//         exact: true,
//         component: OurStory,
//         routes: [
//             {
//                 path: "/our-story",
//                 key: "2",
//                 exact: true,
//                 component: OurStory,
//             }
//         ],
//     },
//     {
//         path: "/features",
//         key: "3",
//         exact: true,
//         component: Features,
//         routes: [
//             {
//                 path: "/features",
//                 key: "3",
//                 exact: true,
//                 component: Features,
//             }
//         ],
//     },
//     {
//         path: "/myindici-for-providers",
//         key: "4",
//         exact: true,
//         component: MyIndiciForProviders,
//         routes: [
//             {
//                 path: "/myindici-for-providers",
//                 key: "4",
//                 exact: true,
//                 component: MyIndiciForProviders,
//             }
//         ],
//     },
//     {
//         path: "/help-center",
//         key: "4",
//         exact: true,
//         component: HelpCenter,
//         routes: [
//             {
//                 path: "/help-center",
//                 key: "4",
//                 exact: true,
//                 component: HelpCenter,
//             }
//         ],
//     },
//     {
//         path: "/videos",
//         key: "4",
//         exact: true,
//         component: Video,
//         routes: [
//             {
//                 path: "/videos",
//                 key: "4",
//                 exact: true,
//                 component: Video,
//             }
//         ],
//     },
//     {
//         path: "/faqs",
//         key: "4",
//         exact: true,
//         component: FAQ,
//         routes: [
//             {
//                 path: "/faqs",
//                 key: "4",
//                 exact: true,
//                 component: FAQ,
//             }
//         ],
//     },
//     {
//         path: "/contactus",
//         key: "4",
//         exact: true,
//         component: ContactUs,
//         routes: [
//             {
//                 path: "/contactus",
//                 key: "4",
//                 exact: true,
//                 component: ContactUs,
//             }
//         ],
//     },
//     {
//         path: "/xyz",
//         key: "4",
//         exact: true,
//         component: MyAccordion,
//         routes: [
//             {
//                 path: "/xyz",
//                 key: "4",
//                 exact: true,
//                 component: ContactUs,
//             }
//         ],
//     },
   
    
// ];
export default ROUTES
export function RenderRoutes({ routes }: { routes: routes[] }) {
    return (
        <Switch>
        {routes.map((route, i) => (
            <Route
                key={route.key}
                path={route.path}
                exact={route.exact}
                render={props => <route.component {...props} routes={route.routes} />}
            />
        ))}
        <Route component={() => <h1>Not Found! Sec</h1>} />
    </Switch>
    );
}
function RouteWithSubRoutes(route: routes) 
{
    return (
        <Route
            key={route.key}
            path={route.path}
            exact={route.exact}
            render={props => <route.component {...props} routes={route.routes} />}
        />
    );
}